"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const exclamation_triangle_icon_1 = require("@patternfly/react-icons/dist/js/icons/exclamation-triangle-icon");
const common_1 = require("../../../../common");
const constants_1 = require("./constants");
const PlatformIntegrationNote = ({ platformType }) => {
    const integrationPlatformLink = constants_1.ExternalPlatformLinks[platformType];
    return (react_1.default.createElement("p", null,
        react_1.default.createElement(common_1.UiIcon, { status: "warning", icon: react_1.default.createElement(exclamation_triangle_icon_1.ExclamationTriangleIcon, null) }),
        " You will need to modify your platform configuration after cluster installation is completed.",
        ' ',
        !!integrationPlatformLink && (react_1.default.createElement("a", { href: integrationPlatformLink || '', target: "_blank", rel: "noopener noreferrer", "data-ouia-component-id": "vm-integration-kb-page" },
            "Learn more ",
            react_1.default.createElement("i", { className: "fas fa-external-link-alt" })))));
};
exports.default = PlatformIntegrationNote;
//# sourceMappingURL=PlatformIntegrationNote.js.map